import { FunctionComponent, useState } from "react";
import ModalOpen from "../../../../../components/modalExportar/components/modal";
import LayersRoundedIcon from '@mui/icons-material/LayersRounded';
import { Button, Grid } from "@mui/material";
import api from "../../../../../utils/api";
import axios from "axios";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { UseGetMembrosParticipantes } from "../../context/getMembros";
import useNav from "../../../../../hooks/useNav";

interface ActionsButtonProps {

}

const ActionsComponent: FunctionComponent<ActionsButtonProps> = () => {

  const { setMensagemSuccess, setMensagemError } = useErrorSuccess()
  const { listAll, refecth } = UseGetMembrosParticipantes();
  const { navTo } = useNav()
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleNinguem = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    try {
      console.log(listAll);
      await axios.all(
        listAll.map(
          (list) => api.put(`evento/ingresso/${list.ingresso}`, { checkin: false })
        )
      );

      setMensagemSuccess('Todos os membros desse evento ficarem sem presença.')
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    } finally {
      await refecth();
      setIsLoading(false);
    }
  }


  const handlePresent = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      await axios.all(
        listAll.map(
          (list) => api.put(`evento/ingresso/${list.ingresso}`, { checkin: true })
        )
      ).then(
        () =>
          setMensagemSuccess('Todos os membros desse evento ficaram com presença.')
      );
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    } finally {
      await refecth();
      setIsLoading(false);
    }
  }

  return (<>
    <ModalOpen buttonStyle={{ startIcon: <LayersRoundedIcon />, variant: 'contained', sx: { boxShadow: 'none' } }} title="Ações">
      <>
        <Grid sx={{ display: 'grid', gap: '4px' }}>
          <Button color="error" onClick={handleNinguem}>Nínguem Presente</Button>
          <Button onClick={handlePresent}>Todos Presentes</Button>
          <Button color="warning" onClick={() => navTo('alocar')}>Alocar Batismo</Button>
        </Grid>
      </>
    </ModalOpen>
  </>);
}

export default ActionsComponent;
